// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".found-cheaper__info[data-v-f26388c0]{flex-grow:1;font-size:11px;line-height:15px;color:#897f58}.found-cheaper__info-link[data-v-f26388c0]{color:#897f58;text-decoration:none;border-bottom:1px solid rgba(0,0,0,.12)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
